import { useContext, useMemo, type ReactNode } from "react";

import { TrackingScopeContext, type TrackingScopeValue } from "@/contexts/trackingScopeContext";

export function TrackingScope({
  children,
  entityType,
  surface,
}: Partial<TrackingScopeValue> & { children: ReactNode }) {
  const parent = useContext(TrackingScopeContext);
  const value = useMemo(
    () => ({
      entityType: entityType ?? parent.entityType,
      surface: surface ?? parent.surface,
    }),
    [entityType, parent.entityType, parent.surface, surface],
  );

  return <TrackingScopeContext.Provider value={value}>{children}</TrackingScopeContext.Provider>;
}
